import { type FC, memo, useCallback } from "react";
import { TrashIcon } from "@snapchat/snap-design-system-icons";
import { VendorDataEntryModel } from "../models";
import { type VendorDataChangedAction } from "../vendorDataReducer";
import { PairContainer, RemoveIconButton } from "./VendorDataSection.styles";
import { VendorDataTitleInput } from "./VendorDataTitleInput";
import { VendorDataValueInput } from "./VendorDataValueInput";

interface VendorDataInputsProps {
    isDuplicate: boolean;
    disabled: boolean;
    entry: VendorDataEntryModel;
    onVendorDataChanged: (event: VendorDataChangedAction) => void;
}

export const VendorDataInputs: FC<VendorDataInputsProps> = memo(
    ({ entry, onVendorDataChanged, isDuplicate, disabled }) => {
        const removeVendorData = useCallback(() => {
            onVendorDataChanged({ type: "remove", entry });
        }, [entry, onVendorDataChanged]);

        return (
            <PairContainer justifyContent="space-between" alignItems="flex-start">
                <VendorDataTitleInput
                    disabled={disabled}
                    entry={entry}
                    onVendorDataChanged={onVendorDataChanged}
                    isDuplicate={isDuplicate}
                />
                <VendorDataValueInput disabled={disabled} entry={entry} onVendorDataChanged={onVendorDataChanged} />
                <RemoveIconButton
                    data-testid="remove-button"
                    shape="circle"
                    isDisabled={disabled}
                    onClick={removeVendorData}
                >
                    <TrashIcon />
                </RemoveIconButton>
            </PairContainer>
        );
    },
);
